///invoicedraft/list
export const INVOICE_DRAFT_LIST_REQUEST = "INVOICE_DRAFT_LIST_REQUEST";
export const INVOICE_DRAFT_LIST_SUCCESS = "INVOICE_DRAFT_LIST_SUCCESS";
export const INVOICE_DRAFT_LIST_FAILURE = "INVOICE_DRAFT_LIST_FAILURE";
///invoice/search
export const INVOICE_DRAFT_SEARCH_REQUEST = "INVOICE_DRAFT_SEARCH_REQUEST";
export const INVOICE_DRAFT_SEARCH_SUCCESS = "INVOICE_DRAFT_SEARCH_SUCCESS";
export const INVOICE_DRAFT_SEARCH_FAILURE = "INVOICE_DRAFT_SEARCH_FAILURE";
///invoicedraft/create
export const INVOICE_DRAFT_CREATE_REQUEST = "INVOICE_DRAFT_CREATE_REQUEST";
export const INVOICE_DRAFT_CREATE_SUCCESS = "INVOICE_DRAFT_CREATE_SUCCESS";
export const INVOICE_DRAFT_CREATE_FAILURE = "INVOICE_DRAFT_CREATE_FAILURE";
///invoicedraft/update
export const INVOICE_DRAFT_UPDATE_REQUEST = "INVOICE_DRAFT_UPDATE_REQUEST";
export const INVOICE_DRAFT_UPDATE_SUCCESS = "INVOICE_DRAFT_UPDATE_SUCCESS";
export const INVOICE_DRAFT_UPDATE_FAILURE = "INVOICE_DRAFT_UPDATE_FAILURE";
///invoicedraft/void
export const INVOICE_DRAFT_VOID_REQUEST = "INVOICE_DRAFT_VOID_REQUEST";
export const INVOICE_DRAFT_VOID_SUCCESS = "INVOICE_DRAFT_VOID_SUCCESS";
export const INVOICE_DRAFT_VOID_FAILURE = "INVOICE_DRAFT_VOID_FAILURE";
///invoicedraft/pdf
export const INVOICE_DRAFT_PDF_REQUEST = "INVOICE_DRAFT_PDF_REQUEST";
export const INVOICE_DRAFT_PDF_SUCCESS = "INVOICE_DRAFT_PDF_SUCCESS";
export const INVOICE_DRAFT_PDF_FAILURE = "INVOICE_DRAFT_PDF_FAILURE";
///invoice/dailybalance
export const INVOICE_DRAFT_DAILY_BALANCE_REQUEST =
  "INVOICE_DRAFT_DAILY_BALANCE_REQUEST";
export const INVOICE_DRAFT_DAILY_BALANCE_SUCCESS =
  "INVOICE_DRAFT_DAILY_BALANCE_SUCCESS";
export const INVOICE_DRAFT_DAILY_BALANCE_FAILURE =
  "INVOICE_DRAFT_DAILY_BALANCE_FAILURE";
///invoicedraftstatus/list
export const INVOICE_DRAFT_STATUS_LIST_REQUEST =
  "INVOICE_DRAFT_STATUS_LIST_REQUEST";
export const INVOICE_DRAFT_STATUS_LIST_SUCCESS =
  "INVOICE_DRAFT_STATUS_LIST_SUCCESS";
export const INVOICE_DRAFT_STATUS_LIST_FAILURE =
  "INVOICE_DRAFT_STATUS_LIST_FAILURE";
///invoicedraftstatus/data
export const INVOICE_DRAFT_STATUS_DATA_REQUEST =
  "INVOICE_DRAFT_STATUS_DATA_REQUEST";
export const INVOICE_DRAFT_STATUS_DATA_SUCCESS =
  "INVOICE_DRAFT_STATUS_DATA_SUCCESS";
export const INVOICE_DRAFT_STATUS_DATA_FAILURE =
  "INVOICE_DRAFT_STATUS_DATA_FAILURE";
///invoicedraftstatus/create
export const INVOICE_DRAFT_STATUS_CREATE_REQUEST =
  "INVOICE_DRAFT_STATUS_CREATE_REQUEST";
export const INVOICE_DRAFT_STATUS_CREATE_SUCCESS =
  "INVOICE_DRAFT_STATUS_CREATE_SUCCESS";
export const INVOICE_DRAFT_STATUS_CREATE_FAILURE =
  "INVOICE_DRAFT_STATUS_CREATE_FAILURE";
///invoicedraftstatus/update
export const INVOICE_DRAFT_STATUS_UPDATE_REQUEST =
  "INVOICE_DRAFT_STATUS_UPDATE_REQUEST";
export const INVOICE_DRAFT_STATUS_UPDATE_SUCCESS =
  "INVOICE_DRAFT_STATUS_UPDATE_SUCCESS";
export const INVOICE_DRAFT_STATUS_UPDATE_FAILURE =
  "INVOICE_DRAFT_STATUS_UPDATE_FAILURE";
///invoicedraftstatus/delete
export const INVOICE_DRAFT_STATUS_DELETE_REQUEST =
  "INVOICE_DRAFT_STATUS_DELETE_REQUEST";
export const INVOICE_DRAFT_STATUS_DELETE_SUCCESS =
  "INVOICE_DRAFT_STATUS_DELETE_SUCCESS";
export const INVOICE_DRAFT_STATUS_DELETE_FAILURE =
  "INVOICE_DRAFT_STATUS_DELETE_FAILURE";

///invoicedraft/data/
export const INVOICE_DRAFT_DATA_REQUEST = "INVOICE_DRAFT_DATA_REQUEST";
export const INVOICE_DRAFT_DATA_SUCCESS = "INVOICE_DRAFT_DATA_SUCCESS";
export const INVOICE_DRAFT_DATA_FAILURE = "INVOICE_DRAFT_DATA_FAILURE";

///invoicedraftactivitylog/search
export const INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST =
  "INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST";
export const INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_SUCCESS =
  "INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_SUCCESS";
export const INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_FAILURE =
  "INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_FAILURE";

///invoicedraft/converttoinvoice
export const INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST =
  "INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST";
export const INVOICE_DRAFT_CONVERT_TO_INVOICE_SUCCESS =
  "INVOICE_DRAFT_CONVERT_TO_INVOICE_SUCCESS";
export const INVOICE_DRAFT_CONVERT_TO_INVOICE_FAILURE =
  "INVOICE_DRAFT_CONVERT_TO_INVOICE_FAILURE";
